module.exports = __webpack_public_path__ + "img/Firefox_Screenshot_2021-10-29T11-14-53.518Z.ccc2fe12.png";